(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("THREE"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "THREE", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["NewSock"] = factory(require("React"), require("THREE"), require("ReactDOM"));
	else
		root["NewSock"] = factory(root["React"], root["THREE"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__49__) {
return 